<!-- 
	This is the tables page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
          :bordered="false"
          class="header-solid h-full"
          :bodyStyle="{ padding: 0 }"
        >
          <div class="top_box">
            <div class="top_left">
              <div class="avatar-uploader">
                <img
                  v-if="imageUrl"
                  style="border-radius: 50%; width: 100%; height: 100%"
                  :src="imageUrl"
                  alt="avatar"
                />
                <div v-else>
                  <loading-outlined v-if="loading"></loading-outlined>
                  <div class="ant-upload-text">LOGO</div>
                </div>
              </div>
              <div class="top_info">
                <div class="top_centont">
                  <div class="top_info_item">
                    <div class="top_item_left">用户ID:</div>
                    <div class="top_item_right">{{ userInfo.account }}</div>
                  </div>
                  <div class="top_info_item">
                    <div class="top_item_left">企业名称:</div>
                    <div class="top_item_right">{{ userInfo.name }}</div>
                  </div>
                  <div class="top_info_item">
                    <div class="top_item_left">用户状态:</div>
                    <div class="top_item_right">
                      <a-tag color="green"> 正常 </a-tag>
                    </div>
                  </div>
                </div>
                <div class="balance_box">
                  <div style="font-size: 20px">剩余次数：</div>
                  <div class="top_item_pre">{{ userInfo.balance }}</div>
                  <a-button
                    v-if="userId == '1846113885128491010'"
                    type="primary"
                    @click="getRechargepackage"
                  >
                    余额充值
                  </a-button>
                </div>
              </div>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <CardAuthorTable
          :total="pagination.total"
          :current="pagination.current"
          :data="table1Data"
          :pageSize="pagination.pageSize"
          :columns="table1Columns"
          @tableChange="tableChange"
        ></CardAuthorTable>
      </a-col>
    </a-row>

    <a-modal v-model="visible" title="余额充值" width="900px" @ok="handleOk">
      <a-form :form="form">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="剩余数量(条)"
        >
          <div>{{ userInfo.balance }}</div>
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="类型"
        >
          <a-radio-group v-model="rechargeType" button-style="solid">
            <a-radio-button value="1"> 套餐 </a-radio-button>
            <a-radio-button value="2"> 自定义 </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-if="rechargeType == '1'"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="套餐列表"
        >
          <div class="mealBox">
            <div
              class="mealItem"
              :class="selectId == item.id ? 'active_item' : ''"
              v-for="(item, index) in rechargeList"
              :key="index"
              @click="selectIdChange(item)"
            >
              <div class="recharge_count">{{ parseInt(item.rechargeCount + item.giveCount)  }}条</div>
              <div class="recharge_amount">
                <div class="amount_text">售价:</div>
                <div class="amount_num">¥ {{ item.rechargeAmount }}</div>
              </div>
              <div class="remark">
                {{ item.remark }}
              </div>
              <div v-if="index == 2" class="tag_class">
                推荐
              </div>
            </div>
          </div>
        </a-form-item>

        <a-form-item
          v-if="rechargeType == '2'"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="自定义数量(条)"
        >
          <a-input
            v-model="payNum"
            type="number"
            placeholder="请输入自定义数量（条）"
            @keydown="filterNum($event)"
          />
        </a-form-item>
        <a-form-item
          v-if="rechargeType == '2'"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="单价"
        >
          <div>{{ checkBalance }} 元/条</div>
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="支付方式:"
        >
          <a-radio-group v-model="formData.payType">
            <a-radio value="aliPay">
              <a-icon
                type="alipay-circle"
                style="font-size: 16px; color: #3892f8"
              />
              <span style="margin-left: 5px">支付宝</span>
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="支付金额"
        >
          <div style="color: red; font-size: 20px">¥ {{ payAmountNum }}</div>
        </a-form-item>

        <a-form-item
          :label-col="formTailLayout.labelCol"
          :wrapper-col="formTailLayout.wrapperCol"
        >
          <a-checkbox v-model="checkNick">
            我已阅读并同意
            <a href=""> 充值服务协议 </a>
          </a-checkbox>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import CardAuthorTable from "./components/CardAuthorTable";
import { getInfo } from "@/api/user";
import {
  getRechargerecord,
  getRechargepackage,
  getSingleCheckBalance,
  alipayPost,
} from "@/api/topUp.js";

const table1Columns = [
  {
    title: "序号",
    dataIndex: "key",
    scopedSlots: { customRender: "key" },
  },
  {
    title: "订单编号",
    dataIndex: "orderNo",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "金额（¥）",
    dataIndex: "rechargeAmount",
  },
  {
    title: "充值数量",
    dataIndex: "rechargeCount",
    scopedSlots: { customRender: "rechargeCount" },
  },
  {
    title: "充值时间",
    dataIndex: "rechargeTime",
  },

  {
    title: "充值结果",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
];

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const formTailLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18, offset: 4 },
};
export default {
  components: {
    CardAuthorTable,
  },
  data() {
    return {
      userId: "",
      userInfo: {},
      searchKey: "",
      visible: false,
      fileList: [],
      imageUrl: "",
      loading: false,
      table1Data: [],
      table1Columns,
      pagination: {
        showQuickJumper: true,
        showSizeChanger: true,
        total: 3,
        pageSize: 10,
        current: 1,
      },
      checkNick: false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: "dynamic_rule" }),
      rechargeList: [],
      checkBalance: 0,
      selectId: "",
      selectAmount: 0,
      rechargeType: "1",
      payNum: 1,
      formData: {
        payType: "aliPay",
      },
      htmlText: "",
    };
  },
  computed: {
    payAmountNum() {
      if (this.rechargeType == "1") {
        return this.selectAmount;
      } else if (this.rechargeType == "2") {
        console.log(this.payNum, this.checkBalance, "1111");
        let payNum = this.payNum ? this.payNum : 0;
        let checkBalance = this.checkBalance ? this.checkBalance : 0;
        return (payNum * checkBalance).toFixed(2) || 0;
      }
    },
  },
  mounted() {
    this.pageSize = 1;
    this.getInfo();
  },
  methods: {
    getInfo() {
      getInfo().then((res) => {
        this.userInfo = res;
        this.userId = res.id;
        this.imageUrl = res.avatar;
        this.getRechargerecord();
      });
    },
    getRechargerecord() {
      // console.log(this.userId)
      getRechargerecord({
        searchKey: this.searchKey,
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        this.table1Data = res.records;
        this.pagination.total = res.total;
      });
    },
    checkboxChange(e) {
      this.checkNick = e.target.checked;
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    handleOk() {
      if (!this.checkNick) {
        this.$message.warning("请阅读并同意充值服务协议");
        return;
      }
      if (this.rechargeType == "1" && !this.selectId) {
        this.$message.warning("请选择套餐");
        return;
      }
      if (this.rechargeType == "2" && !this.payNum) {
        this.$message.warning("请输入正确的自定义数量");
        return;
      }
      let data =
        this.rechargeType == "1"
          ? { rechargePackageId: this.selectId }
          : { singleCheckNum: this.payNum };
      alipayPost(data).then((res) => {
        console.log(res);
        this.htmlText = res.body;
        //xxxxx为请求到的form数据
        document.querySelector("body").innerHTML = this.htmlText;
        document.forms[0].submit();
      });
    },
    tableChange(e) {
      this.pagination = e;
      this.getReportList();
    },
    // 获取套餐列表
    getRechargepackage() {
      getRechargepackage().then((res) => {
        this.visible = true;
        this.rechargeList = res.records;
        if (res.records && res.records.length > 0) {
          this.selectId = res.records[0].id;
          this.selectAmount = res.records[0].rechargeAmount;
        }
        this.getSingleCheckBalance();
      });
    },
    getSingleCheckBalance() {
      getSingleCheckBalance().then((res) => {
        this.checkBalance = res;
        // this.checkBalance = 0.01;
      });
    },
    selectIdChange(item) {
      this.selectId = item.id;
      this.selectAmount = item.rechargeAmount;
    },
    //用于防止输入负数和小数
    filterNum(e) {
      let prohibitInput = ["-", "."];
      if (prohibitInput.includes(e.key)) {
        e.preventDefault();
      }
    },

    validateInteger(e, type) {
      let val = e.data;
      // 限制不能输入字符
      if (isNaN(Number(val))) {
        this.formData[type] = 1;
      }
      // 限制不能输入负数
      if (Number(val) < 0) {
        this.formData[type] = 1;
      }
      // 限制不能输入小数
      if (val.indexOf(".") > -1) {
        this.formData[type] = val.split(".")[0];
        return;
      }
      // 如果首位是0，那么默认删除
      if (val.length > 1 && val[0] == 0) {
        this.formData[type] = val.slice(1);
      }
    },
  },
};
</script>

<style lang="scss">
.avatar-uploader {
  width: auto !important;
  .ant-upload {
    border-radius: 50%;
    background-color: #fff;
  }
}
.top_box {
  display: flex;
  justify-content: space-between;
  padding: 30px 50px;
  .top_left {
    flex: 1;
    display: flex;
    .top_info {
      display: flex;
      justify-content: space-between;
      .balance_box {
        display: flex;
        align-items: center;
        .top_item_pre {
          font-size: 45px;
          font-weight: bold;
          margin-right: 20px;
        }
      }
      .top_centont {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;
        margin-right: 30px;
        padding-right: 30px;
        border-right: 1px #d8d8d8 solid;
        .top_info_item {
          display: flex;
          align-items: center;
          .top_item_left {
            width: 80px;
            text-align: right;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
.pay_type_class {
  display: inline-flex;
  align-items: center;
}
.mealBox {
  display: flex;
  flex-wrap: wrap;
  .mealItem {
    display: flex;
    width: 31%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #00000020;
    border-radius: 10px;
    padding: 10px 20px;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    .recharge_count {
      font-size: 32px;
      font-weight: bold;
    }
    .recharge_amount {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      line-height: 18px;
      margin: 5px 0;
      // color: #1890FF;
      .amount_text {
        margin-right: 5px;
      }
      .amount_num {
        font-size: 24px;
      }
    }
    .remark {
      margin-top: 10px;
      font-size: 14px;
      line-height: 14px;
      // color: red;
    }
    .tag_class{
      position: absolute;
      top: 0;
      right: 0;
      background: #1890ff;
      color: #fff;
      height: 25px;
      line-height: 25px;
      padding: 0 6px;
      font-size: 13px;


    }
  }
  .active_item {
    background: #ebf5ff;
    color: #1890ff;
    border: 1px solid #1890ff;
  }
}
</style>
